/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetApiKeysQuery, ApiKeysSortInput } from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort: ApiKeysSortInput;
};

export function useGetApiKeys({ page, limit, sort }: Props) {
  const { data, loading, error, refetch } = useGetApiKeysQuery({
    variables: { page: Number(page), limit: Number(limit), sort },
  });

  const count = data?.apiKeys.pageInfo?.count ?? 0;

  return {
    data: data?.apiKeys?.result ?? [],
    loading,
    error,
    count,
    refetch,
  } as const;
}
